<style lang="scss" scoped>
    .code-submit-button {
        font-size: 1.5em;
    }
</style>

<template>
    <div>
        <form class="sirs-survey" ref="surveyForm" @submit.prevent="onClickSubmit">
            <!-- SHOW FORM TO ENTER ACCESS CODE -->
            <template v-if="!isAccessCodeAccepted">
                <div class="text-center">
                    <!-- SHOW SPINNER WHILE ACCESS CODE IS CHECKED -->
                    <template v-if="isAccessCodeBeingFetched">
                        <div class="text-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Checking access code...</span>
                            </div>
                        </div>
                    </template>

                    <!-- SHOW INPUT BOX TO ENTER ACCESS CODE -->
                    <template v-else>
                        <p>Please enter the quiz code found at the end of the {{ trainingTitle }} training video. To return to the training, click Play Video under your session name.</p>
                        <input v-model="accessCode" placeholder="Enter Quiz Code" @keydown.enter="onEnterAccessCode">
                        <button type="button" @click="onEnterAccessCode" class="btn btn-default code-submit-button" aria-lable="Submit Code">
                            <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                        </button>


                        <!-- SHOW ACCESS CODE INPUT ERRORS -->
                        <div v-if="accessCodeError.length > 0" class='alert alert-danger mx-auto w-50'>{{ accessCodeError }}</div>
                    </template>
                </div>
            </template>

            <!-- SHOW FORM FOR KNOWLEDGE QUIZ -->
            <template v-else>
                <survey-modal
                    :training-session="trainingSession"
                    survey-type="knowledge-quiz"
                ></survey-modal>
            </template>

            <template v-if="isDev && !accessCodeSkipped">
                <button @click="overrideAccessCode" type="button" class="btn btn-orange-blue">Skip access code?</button>
            </template>
        </form>
        <div v-if="!isQuizLoading" class="alert" :class="{'alert-success': (submitMessage.length > 0 && allCorrect), 'alert-danger': (submitMessage.length > 0 && !allCorrect)}" ref="submit-message" role="alert">
            {{ submitMessage }}
        </div>
    </div>
</template>

<script>

    import SurveyModal from './SurveyModal';
    import { mapState, mapMutations } from 'vuex';

    export default{
        components: {
            'survey-modal': SurveyModal,
        },
        props: {
            trainingId: {
                type: Number,
                default: null
            },
            trainingSessionId: {
                type: Number,
                default: null
            },
            isDev: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                isAccessCodeAccepted: false,
                isAccessCodeBeingFetched: false,
                accessCode: "",
                accessCodeError: "",
                accessCodeSkipped: false,
                submitMessage: "",
                allCorrect: false,
            }
        },
        methods: {
            onClickSubmit() {
                this.updateLoadStatus({isQuizLoading: true});

                let vm = this;
                let data = new FormData(this.$refs.surveyForm);
                data.append('nav', 'finalize');

                axios.post('training-session/' + vm.trainingSessionId + '/knowledge-quiz', data)
                .then(response => {
                    if(response.data.hasMaxScore === true) {
                        vm.allCorrect = true;
                        vm.submitMessage = "Congratulations! You have passed the " + vm.trainingTitle + " training. Please return to the Trainings Page to complete your training session evaluation and print your certificate.";
                    } else {
                        vm.submitMessage = response.data.correctCount + "/" + response.data.totalQuestions + " questions correct. You must answer all quiz questions correctly before proceeding. Please try again.";
                    }
                    
                    let trainingSessionId = response.data.trainingSessionId;
                    let trainingSession = response.data.trainingSession;
                    let latestQuizResponse = response.data.latestQuizResponse;

                    vm.updateLatestResponse({trainingSessionId, latestQuizResponse});
                    vm.updateTrainingSession({trainingSession, trainingSessionId});
                });

            },

            onEnterAccessCode() {
                this.checkAccessCode();
            },
            checkAccessCode() {
                let vm = this;
                this.isAccessCodeBeingFetched = true;

                axios.post('training-session/' + this.trainingSessionId + '/access-code/check', {
                    access_code: vm.accessCode.toUpperCase()
                })
                .then(response => {
                    vm.isAccessCodeBeingFetched = false;

                    vm.isAccessCodeAccepted = response.data.allowed;

                    if(!vm.isAccessCodeAccepted) {
                        vm.accessCodeError = "Incorrect Quiz Code";
                    } 
                });
            },
            overrideAccessCode() {
                this.isAccessCodeAccepted = true;
                this.accessCodeSkipped = true;
            },
            ...mapMutations({
                updateTrainingSession: 'UPDATE_TRAINING_SESSION',
                updateLatestResponse: 'UPDATE_LATEST_QUIZ_RESPONSE',
                updateLoadStatus: 'UPDATE_IS_QUIZ_LOADING',
            }),
        },
        computed: {
            trainingSession() {
                return this.trainingSessions[this.trainingSessionId];
            },
            trainingTitle: function() {
                if(this.trainings && this.trainings[this.trainingId]) {
                    return this.trainings[this.trainingId].title;
                }
                return "";
            },
            ...mapState([
                'trainings',
                'trainingSessions',
                'isQuizLoading',
            ]),
        },
    }
</script>
